import InputBase from '@material-ui/core/InputBase';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

export const CustomKeyboardArrowUpBig = withStyles(theme => ({
  root: {
    color: '#463264',
    fontSize: 32,
  },
}))(KeyboardArrowDown);

export const CustomKeyboardArrowUp = withStyles(theme => ({
  root: {
    color: '#463264',
    fontSize: 18,
    marginTop: 2.5,
  },
}))(KeyboardArrowUp);

export const CustomKeyboardArrowDownBig = withStyles(theme => ({
  root: {
    color: '#463264',
    fontSize: 32,
  },
}))(KeyboardArrowDown);

export const CustomKeyboardArrowDown = withStyles(theme => ({
  root: {
    color: '#463264',
    fontSize: 18,
    marginTop: 2.5,
  },
}))(KeyboardArrowDown);

export const CustomizedInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 10,
    position: 'relative',
    backgroundColor: 'white',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      backgroundColor: 'white',
      borderRadius: 10,
    },
  },
}))(InputBase);

export default CustomizedInput;
